import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Dialog } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { ProgressBar } from 'primeng/progressbar';
import { IdleTimeoutService } from '../../../core/services/idle-timeout.service';

@Component({
  selector: 'app-idle-timeout-dialog',
  standalone: true,
  imports: [CommonModule, Dialog, ProgressBar, Button],
  templateUrl: './idle-timeout-dialog.component.html',
  styleUrl: './idle-timeout-dialog.component.css',
})
export class IdleTimeoutDialogComponent {
  protected readonly idleTimeoutService = inject(IdleTimeoutService);

  // Expose reactive signals to template
  protected readonly isVisible = this.idleTimeoutService.isWarningVisible;
  protected readonly formattedRemainingTime = this.idleTimeoutService.formattedRemainingTime;
  protected readonly progressPercentage = this.idleTimeoutService.progressPercentage;

  protected onKeepLoggedIn(): void {
    this.idleTimeoutService.extendSession();
  }

  protected onLogoutNow(): void {
    this.idleTimeoutService.logoutDueToInactivity();
  }
}
